<script setup>

import { computed } from 'vue';

const props = defineProps({

    change: {
        type: Object,
        required: true
    }

});

const oldValue = computed(() => formatValue(props.change.oldValue));
const newValue = computed(() => formatValue(props.change.newValue));

function formatValue(value) {

    if (value === null)
        return "(null)";

    if (value === undefined)
        return "(undefined)";

    if (typeof value === "boolean")
        return value ? "Tak" : "Nie";

    if (typeof value === "object")
        return JSON.stringify(value, null, 2);

    return value;

}

</script>

<template>

<div class="border-bottom p-3">

    <div class="d-flex align-items-center mb-2">

        <i
            class="fas me-2 text-primary"
            :class="change.icon"
        />

        <div>

            <div class="fw-bold">

                {{ change.label }}

            </div>

            <small
                class="text-muted"
                v-if="change.pathText !== change.label"
            >
                {{ change.pathText }}
            </small>

        </div>

    </div>

    <div class="row">

        <!-- STARA WARTOŚĆ -->

        <div class="col-md-5">

            <div class="text-muted small mb-1">

                Było

            </div>

            <div class="bg-light rounded p-2">

                <pre class="mb-0 value-box">{{ oldValue }}</pre>

            </div>

        </div>

        <!-- STRZAŁKA -->

        <div
            class="col-md-2
                   d-flex
                   justify-content-center
                   align-items-center"
        >

            <i
                class="fas fa-arrow-right fa-lg text-secondary"
            />

        </div>

        <!-- NOWA WARTOŚĆ -->

        <div class="col-md-5">

            <div class="text-success small mb-1">

                Jest

            </div>

            <div
                class="bg-success-subtle border border-success rounded p-2"
            >

                <pre class="mb-0 value-box">{{ newValue }}</pre>

            </div>

        </div>

    </div>

</div>

</template>

<style scoped>

.value-box{

    white-space:pre-wrap;

    word-break:break-word;

    font-family:inherit;

    font-size:14px;

    margin:0;

}

</style>